<template>
  <div class="content">
    <Header></Header>
    <div class="sign" style="disp">
      <div class="left">
        <div class="Share">अपने विचार साझा करें, हमारे जीवन को बेहतर बनाएं</div>
        <div class="left-top">
          <p>आपकी राय महत्वपूर्ण</p>
          <p>है। "WeOpinions" पर सुझाव व्यक्त करें</p>
          <p>और पुरस्कार अर्जित करें।d</p>
        </div>
        <div class="sign-free">फ्री रजिस्ट्रेशन</div>
        <div class="box-btn" @click="skip('/logon')">
          <div class="signup-now">अभी पंजीकरण करें</div>
          <img src="@/assets/pcImg/arrowhead-right.png" />
        </div>
      </div>
      <div class="right">
        <!-- 登录 -->
        <div class="box-sign">
          <div class="title">लॉगिन</div>

          <input
            type="text"
            v-model="loginForm.userName"
            placeholder="इमेल आईडी"
          />
          <input
            :type="inputType"
            class="passworld"
            v-model="loginForm.password"
            placeholder="पासवर्ड"
          />

          <img class="eyes" @click="changeEyes" :src="eyes" />

          <div class="forgot" @click="skip('/forgot')">पासवर्ड भूल गए?</div>

          <button class="submit" @click="login">सबमिट करें</button>

          <div class="have-account" @click="skip('/logon')">
            <div>कोई खाता नहीं है?</div>
            <div>अभी पंजीकरण करें</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-three">
      <div class="box-item twenty">
        <div class="title">हमसे जुड़ें</div>
        <div class="imgs">
          <img src="@/assets/pcImg/join-us.png" />
          <img
            class="green"
            @click="skip('/IntegralAward')"
            src="@/assets/pcImg/arrowhead-green.png"
          />
        </div>
        <p class="million">
          १,५ मिलियन लोगों में जोड़ने के लिए आगे क्या आता है. हस्ताक्षर करें
          आपके इमेल पता के प्रयोग से मुक्त करने के लिए।
        </p>
      </div>
      <div class="box-item">
        <div class="title">अपने विचार साझा करें</div>
        <div class="imgs">
          <img src="@/assets/pcImg/share.png" />
          <img
            class="green"
            @click="skip('/aboutQuestionnaire')"
            src="@/assets/pcImg/arrowhead-green.png"
          />
        </div>
        <p class="million">
          ऑनलाइन स्वीक्षणों में भाग लो, नये उत्पादनों को परीक्षा करो, अल्पवादों
          को देखो और आंखिक दृश्य साझ
        </p>
      </div>
      <div class="box-item twenty">
        <div class="title">इनाम</div>
        <div class="imgs">
          <img src="@/assets/pcImg/rewards.png" />
          <img
            class="green"
            @click="skip('/helpFeedback')"
            src="@/assets/pcImg/arrowhead-green.png"
          />
        </div>
        <p class="million">
          जब आप सहभागी होते हैं, तुम सहभागी होगे। आर्न बिन्दु प्रसिदान कार्ड,
          इंटरनेटेमेंट पैकेजों के लिए रिडीमेबल है क्रेडिट।
        </p>
      </div>
    </div>
    <div class="our-rewards">
      <div>हमारे इनाम</div>
      <div class="imgs">
        <img class="paypal" src="@/assets/pcImg/paypal.png" />
        <img class="walmart" src="@/assets/pcImg/walmart.png" />
        <img class="amazon" src="@/assets/pcImg/amazon.png" />
      </div>
    </div>
    <div class="free">
      <img class="young" src="@/assets/pcImg/young.png" />
      <!-- 占位 -->
      <div></div>
      <!-- 占位 -->
      <div class="receive">
        <div>वेओप्यूशन क्या है?</div>
        <img class="young-nei" src="@/assets/pcImg/young.png" />
        <p>
          मुफ्त में शामिल हों, और हर बार WeOpinions पर मतदान करने पर पुरस्कार
          अंक
        </p>
        <p>
          प्राप्त करें। उन विषयों को प्रकाशित करें जो आपकी रुचि के हैं और अन्य
        </p>
        <p>
          सदस्यों से पूछें। हमारे समुदाय से जानें कि अन्य लोग इस दुनिया को कैसे
        </p>
        <p>देखते हैं। हम आपकी जानकारी की सुरक्षा सुनिश्चित करते हैं।</p>
      </div>
    </div>
    <div class="free">
      <div class="product">
        <div>मैं अपनी राय के जरिए कैसे पुरस्कार प्राप्त कर सकता हूँ?</div>
        <img class="old-nei" src="@/assets/pcImg/old.png" />
        <p>
          आपका मतलब उत्पाद और सेवा के लिए बहुत महत्वपूर्ण है। आपका मतलब है उनके
          लिए बहुत मूल्यवान है।
        </p>
        <p>
          ज्यादा विशेषता है कि हम दान वुचर्स और प्रतिदान के साथ पैसा किया जाता
          है.
        </p>
        <p>वेविकल्पों के द्वारा प्रतिदान और पैसा सुनाना बहुत आसान है।</p>
        <p>इस प्लेटफ़ॉर्म के प्रयोग से आप उत्साहित प्रतिदान और पैसा मूल्य प्राप्त कर सकते हैं.</p>
        <p>तुम द्वारा जीत सकते हो;</p>
      </div>
      <img class="old" src="@/assets/pcImg/old.png" />
    </div>
    <Footer @changeCookieNoticeShow="changeCookieNoticeShow"></Footer>
    <CookieNotice v-if="cookieNoticeShow" @notAccept="notAccept"></CookieNotice>
  </div>
</template>
<script>
import { login as authLogin, accounts } from "@/api/api.js";
import { Notify } from "vant";
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import CookieNotice from "./mycom/cookieNotice.vue";
export default {
  components: { Header, Footer, CookieNotice },
  data() {
    return {
      cookieNoticeShow: false,
      inputType: "password",
      eyes: require("@/assets/pcImg/close-eyes.png"),
      isSign: true,
      loginForm: {
        userName: "",
        password: "",
      },
    };
  },
  methods: {
    changeCookieNoticeShow(value) {
      this.cookieNoticeShow = value;
    },
    notAccept(value) {
      this.cookieNoticeShow = value;
    },
    // 跳转
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    // 登录点击眼睛切换
    changeEyes() {
      if (this.inputType === "password") {
        this.inputType = "text";
        this.eyes = require("@/assets/pcImg/open-eyes.png");
        return;
      }
      if (this.inputType === "text") {
        this.inputType = "password";
        this.eyes = require("@/assets/pcImg/close-eyes.png");
        return;
      }
    },
    //登录
    async login() {
      let params = this.loginForm;
      await authLogin(params).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.loginSuccessed"),
          });
          localStorage.setItem("LOGIN_INFO", JSON.stringify(res.data));
          this.getAccountInfo(res.data.id);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //跳转
    async getAccountInfo(id) {
      await accounts({ id }).then((res) => {
        if (res.code === 200) {
          if (res.data.isBlacklist) {
            this.$router.push("/mine");
          } else {
            this.$router.push("/questionnaire");
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    //修改title
    document.title =
      "Paid Online Surveys | Paid Surveys | WeOpinions description: Weopinions is a market research and Survey panel where members collect points for their opinions. Collected points can be exchanged for gift-cards.";
  },
};
</script>
<style scoped>
.content {
  width: 100%;
  /* min-width: 853.75px; */
  height: 100vh;
  background-color: #f8f8f7;
  overflow: auto;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 99;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
/* 注册登录第二屏 */
.sign {
  width: 100%;
  height: 520.625px;
  background-image: url("..//assets/pcImg/sign.png");
  background-size: cover;
  background-position-y: 60%;
  background-color: #2e67ea;
  display: flex;
  justify-content: space-between;
}
.sign > .left {
  margin-left: 87.5px;
  color: #fff;
}
.left > .Share {
  width: 324.375px;
  height: 78.125px;
  font-size: 31.25px;
  font-weight: 500;
  line-height: 43.75px;
  margin-top: 91.25px;
  margin-bottom: 29.375px;
}
.left > .left-top {
  margin-top: 80px;
}
.left > div > p {
  font-size: 11.25px;
  font-weight: 400;
  color: #c0d1f9;
  margin-bottom: 10px;
}
.sign-free {
  font-size: 12.5px;
  font-weight: bold;
  color: #ffffff;
  margin-top: 22.5px;
  margin-bottom: 34.375px;
}
.box-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 129.375px;
  height: 35px;
  border-radius: 35px;
  background-color: #fff;
  color: #1e195e;
  cursor: pointer;
}
.signup-now {
  font-size: 11.25px;
  margin-left: 11.25px;
  font-weight: bold;
}
.box-btn > img {
  width: 26.25px;
  height: 26.25px;
  margin-right: 6.875px;
}

.right {
  display: flex;
  justify-content: flex-end;
}
.right > .box-sign {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 187.5px;
  height: 250px;
  background: #1f1962;
  border-radius: 6.25px;
  margin-top: 98.75px;
  margin-right: 87.5px;
  padding-left: 43.75px;
  padding-right: 43.75px;
  color: #fff;
}
.box-sign > .title {
  font-size: 15px;
  margin-top: 18.75px;
  margin-bottom: 20px;
}
.box-sign > input {
  border: none;
  height: 25px;
  width: calc(100% - 16.25px);
  color: #757575;
  font-size: 10px;
  padding-left: 16.25px;
  border-radius: 2.5px;
}
.box-sign > input.passworld {
  width: calc(100% - 46.25px);
  padding-right: 30px;
  margin-top: 20.625px;
}
.box-sign > .eyes {
  position: absolute;
  width: 15px;
  height: 15px;
  right: 51.25px;
  top: 106.25px;
  cursor: pointer;
}
.forgot {
  width: 100%;
  text-align: right;
  font-size: 8.75px;
  margin-top: 10px;
  color: #acaac5;
  cursor: pointer;
}
.box-sign > .submit {
  width: 100%;
  height: 25px;
  background: #ffffff;
  border-radius: 25px;
  color: #141212;
  margin-top: 22.5px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
}
.or {
  margin-top: 13.65px;
  margin-bottom: 11.25px;
  font-size: 8.75px;
}
.boxs {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 8.75px;
  font-weight: bold;
}
.twitter {
  width: 90px;
  height: 22.5px;
  line-height: 22.5px;
  background: #79a8e3;
  border-radius: 22.5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.twitter > .dickey {
  width: 12.875px;
  width: 12.875px;
  margin-left: 11.25px;
}
.twitter > div {
  margin-right: 11.25px;
}
.likdin {
  width: 90px;
  height: 22.5px;
  line-height: 22.5px;
  text-align: center;
  background: #79a8e3;
  border-radius: 22.5px;
  display: flex;
  justify-content: space-between;
}
.likdin > span {
  margin-left: 11.25px;
  margin-right: 11.25px;
  border: none;
}
.have-account {
  display: flex;
  justify-content: space-between;
  font-size: 8.75px;
  color: #acaac5;
  width: 100%;
  margin-top: 14.375px;
  cursor: pointer;
}

/* 注册 */
.verification-code,
.confirm {
  margin-top: 20.625px;
}
/* 三个 第三屏*/
.box-three {
  display: flex;
  justify-content: space-between;
}
.box-item {
  width: 33.3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #232323;
  font-weight: bold;
}
.box-item > .title {
  font-size: 18.75px;
  margin-top: 40.625px;
}
.box-item > .imgs {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 70px;
}
.box-item img {
  width: 175px;
  height: 175px;
}
.box-item .green {
  width: 38.75px;
  height: 38.75px;
  margin-top: 18.75px;
  cursor: pointer;
}
.box-item p {
  width: 160px;
  font-size: 10px;
  font-weight: normal;
}
.million {
  width: 200px;
  margin-top: 20px;
  line-height: 15px;
}
/* 三个卡片 */
.our-rewards {
  margin-top: 54.375px;
  font-size: 31.25px;
  font-weight: bold;
}
.our-rewards div {
  width: 100%;
  text-align: center;
}
.our-rewards .imgs {
  display: flex;
  justify-content: space-around;
  margin-top: 70px;
}
.our-rewards .imgs img {
  width: 214px;
  height: 131.25px;
}
/* 介绍 */
.free {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 80px;
}
.free .young {
  width: 252px;
  height: 273px;
}
.free .receive {
  color: #232323;
  text-align: right;
  margin-right: 20px;
}
.receive > div {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 50px;
}
.receive > p {
  margin-top: 10px;
  font-size: 12.5px;
  font-weight: 500;
}
.free .product {
  color: #232323;
  margin-left: 20px;
}
.free .old {
  width: 293.125px;
  height: 293.125px;
}
.product > div {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 43.75px;
}
.product > p {
  margin-top: 10px;
  font-size: 12.5px;
  font-weight: 500;
}

.young-nei {
  display: none;
}
.old-nei {
  display: none;
}
</style>
<style scoped>
@media only screen and (max-width: 1234px) {
  .sign > .left {
    margin-left: 20px;
  }
  .sign > .right {
    margin-right: 20px;
  }
  .sign > .right > .box-sign {
    margin-right: 0;
  }
}
@media only screen and (max-width: 1015px) {
  .sign > .right {
    display: none;
  }
  .sign > .left {
    margin: 0 auto;
    text-align: center;
  }
  .box-btn {
    margin: 0 auto;
  }
  .box-three {
    justify-content: start;
    flex-wrap: wrap;
  }
  .box-item {
    width: 100%;
  }
  .our-rewards .imgs img {
    width: 30%;
    height: 30%;
  }
  .old,
  .young {
    display: none;
  }
  .young-nei,
  .old-nei {
    display: block;
  }
  .young-nei {
    width: 265.75px;
    height: 287.9px;
    margin-bottom: 20px;
  }
  .old-nei {
    width: 411.25px;
    height: 411.25px;
  }
  .free .receive {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
  }
  .free .product {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
  }
  .receive p {
    width: calc(100% - 40px);
    text-align: center;
  }
  .product div {
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .product p {
    width: calc(100% - 40px);
    text-align: center;
  }
}
@media only screen and (max-width: 768px) {
  .old-nei {
    width: 350px;
    height: 350px;
  }
}
/* 兼容 */
input::-ms-reveal {
  display: none;
}
input::-ms-clear {
  display: none;
}
input::-o-clear {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue